import { InteractiveButtons } from "../InteractiveButtons";
import { CustomUIRoot } from "./CustomUI.styles";

export const CustomUI = (props) => {
  const {
    emitUIInteraction,
    applicationResponse,
    actionsList,
    loading,
    onHandleStartExport,
    showingOverlay,
    onHandleMenuToggle,
    menuOpen,
    isMobile,
  } = props;

  return (
    <CustomUIRoot id="streaming-ui">
      <InteractiveButtons
        applicationResponse={applicationResponse}
        actionsList={actionsList}
        emitUIInteraction={emitUIInteraction}
        loading={loading}
        onStartExport={onHandleStartExport}
        showingOverlay={showingOverlay}
        onHandleMenuToggle={onHandleMenuToggle}
        menuOpen={menuOpen}
        isMobile={isMobile}
      />
    </CustomUIRoot>
  );
};
